import { Dispatch, FC } from "react";
import "./PaginationBar.scss";

import Pagination from "@mui/material/Pagination";
import { SetStateAction } from "../../../models/models.helpers";

export type PaginationBarProps = {
    currentPageHandler: Dispatch<SetStateAction<Page>>;
    totalItems: number;
    pageSize: number;
    currentPage: number;
};

export type Page = number;

export const PaginationBar: FC<PaginationBarProps> = ({
    currentPageHandler,
    totalItems,
    currentPage,
    pageSize,
}) => {
    const count = Math.ceil(totalItems / pageSize);

    return (
        <div className="pagination_bar__container">
            <Pagination
                className="pagination_bar"
                count={count}
                page={currentPage}
                boundaryCount={1}
                siblingCount={1}
                onChange={(e, page) => currentPageHandler(page)}
            />
        </div>
    );
};
